import { Link, useLocation } from "react-router-dom";
import { Airplane } from "@phosphor-icons/react";

export default function PublicHeader() {
  const loc = useLocation();
  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="brand-home-link" className="flex items-center gap-3 group">
          <div className="h-9 w-9 bg-[#0B2046] flex items-center justify-center">
            <Airplane size={18} weight="fill" className="text-white -rotate-45" />
          </div>
          <div className="font-display font-black tracking-tighter text-lg text-slate-900">
            IAVA
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-10 text-sm font-medium text-slate-600">
          <a href="/#how" className="hover:text-slate-900 transition-colors">How it works</a>
          <a href="/#credentials" className="hover:text-slate-900 transition-colors">Credentials</a>
          <a href="/#standards" className="hover:text-slate-900 transition-colors">Standards</a>
        </nav>

        <div className="flex items-center gap-3">
          <Link
            data-testid="header-verify-link"
            to="/"
            className={`text-sm font-medium px-4 py-2 ${
              loc.pathname.startsWith("/verify") || loc.pathname === "/"
                ? "bg-[#0B2046] text-white"
                : "text-slate-700 hover:text-slate-900"
            }`}
          >
            Verify
          </Link>
        </div>
      </div>
    </header>
  );
}
